module.exports = __webpack_public_path__ + "img/admin.bb02b884.png";